import React, { useState, useEffect } from 'react';
import { contentAPI } from '../../services/api';

const NewsTickerSection = () => {
  const [items, setItems] = useState([]);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    loadItems();
  }, []);

  const loadItems = async () => {
    try {
      const res = await contentAPI.getTicker();
      setItems(res.data);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (formData.id) {
        await contentAPI.updateTicker(formData.id, formData);
      } else {
        await contentAPI.createTicker(formData);
      }
      loadItems();
      setFormData({});
      alert('Ticker enregistré!');
    } catch (error) {
      alert('Erreur lors de l\'enregistrement');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Supprimer ce ticker?')) {
      try {
        await contentAPI.deleteTicker(id);
        loadItems();
      } catch (error) {
        alert('Erreur lors de la suppression');
      }
    }
  };

  return (
    <div>
      <h1 style={styles.title}>Gestion de la Barre d'Actualités</h1>
      
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>
          {formData.id ? 'Modifier' : 'Ajouter'} un message
        </h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            placeholder="Texte en français"
            value={formData.text || ''}
            onChange={(e) => setFormData({...formData, text: e.target.value})}
            style={styles.input}
            required
          />
          <input
            type="text"
            placeholder="النص بالعربية"
            value={formData.text_ar || ''}
            onChange={(e) => setFormData({...formData, text_ar: e.target.value})}
            style={styles.input}
            required
          />
          <input
            type="text"
            placeholder="Icône (emoji)"
            value={formData.icon || '📰'}
            onChange={(e) => setFormData({...formData, icon: e.target.value})}
            style={styles.input}
          />
          <input
            type="number"
            placeholder="Ordre d'affichage"
            value={formData.display_order || 0}
            onChange={(e) => setFormData({...formData, display_order: e.target.value})}
            style={styles.input}
          />
          <div style={styles.formActions}>
            <button type="submit" style={styles.submitBtn}>
              {formData.id ? 'Modifier' : 'Ajouter'}
            </button>
            {formData.id && (
              <button type="button" onClick={() => setFormData({})} style={styles.cancelBtn}>
                Annuler
              </button>
            )}
          </div>
        </form>
      </div>

      <div style={styles.card}>
        <h2 style={styles.cardTitle}>Messages actuels ({items.length})</h2>
        {items.map(item => (
          <div key={item.id} style={styles.itemRow}>
            <span style={styles.icon}>{item.icon}</span>
            <div style={styles.itemContent}>
              <div>{item.text}</div>
              <div style={styles.arabicText}>{item.text_ar}</div>
            </div>
            <div style={styles.actions}>
              <button onClick={() => setFormData(item)} style={styles.editBtn}>
                Modifier
              </button>
              <button onClick={() => handleDelete(item.id)} style={styles.deleteBtn}>
                Supprimer
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  title: { fontSize: '32px', fontWeight: 'bold', marginBottom: '30px' },
  card: { background: 'white', padding: '30px', borderRadius: '15px', marginBottom: '30px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  cardTitle: { fontSize: '20px', fontWeight: 'bold', marginBottom: '20px' },
  form: { display: 'flex', flexDirection: 'column', gap: '15px' },
  input: { padding: '12px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '15px' },
  formActions: { display: 'flex', gap: '10px' },
  submitBtn: { padding: '15px', background: '#c41e3a', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', flex: 1 },
  cancelBtn: { padding: '15px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' },
  itemRow: { display: 'flex', alignItems: 'center', gap: '15px', padding: '15px', background: '#f9f9f9', borderRadius: '8px', marginBottom: '10px' },
  icon: { fontSize: '24px' },
  itemContent: { flex: 1 },
  arabicText: { color: '#666', fontSize: '14px', marginTop: '5px' },
  actions: { display: 'flex', gap: '10px' },
  editBtn: { padding: '8px 15px', background: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' },
  deleteBtn: { padding: '8px 15px', background: '#dc3545', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }
};

export default NewsTickerSection;
